<!--
* @Description:相关调研7
* @Date: 2024-01-20 12:21:01
-->
<template>
  <div
    class="patient-sex"
    ref="TaskRef"
    :style="{
      transform: `scale(${scale})`,
      transformOrigin: '0 0'
    }"
  >
    <div class="contnet" ref="ContentRef">
      <div class="contnet-warp">
        <div class="contnet-warp-round" id="warp-round">
          <div class="contnet-warp-round-icon">
            <baseSvg></baseSvg>
          </div>
          <div
            class="contnet-warp-round-item"
            id="roundItems"
            v-for="(item, index) in data.projectName"
            :key="index"
            :style="{ '--color': `var(--theme-color-${index + 1},#000)` }"
          >
            <!-- <div>{{ sequence[index] }}</div> -->
          </div>
          <div
            class="contnet-warp-round-arrow"
            id="arrowItems"
            v-for="(item, index) in data.projectName"
            :key="index"
            :style="{ '--color': `var(--theme-color-${index + 1},#000)` }"
          ></div>
          <div
            class="contnet-warp-round-text"
            id="textItems"
            v-for="(item, index) in data.tipData"
            :key="index"
            :style="{ '--color': `var(--theme-color-${index + 1},#000)` }"
          >
            <div class="contnet-warp-round-text-r">
              <div class="inner" id="text-r">
                <div class="tip">
                  <div>
                    <div v-for="(citem, cindex) in item" :key="cindex">
                      {{ citem.label }}：{{ citem.value }}
                    </div>
                  </div>
                </div>
                <div class="white"></div>
                <div class="bg"></div>
              </div>
            </div>
          </div>
          <div
            class="contnet-warp-round-line"
            id="lines-sex-7"
            v-for="(item, index) in data.projectName"
            :key="index"
            :style="{ '--color': `var(--theme-color-${index + 1},#000)` }"
          ></div>
        </div>
      </div>

      <!-- 项目名称 -->

      <div class="content-name">
        <div>
          <div
            :style="{ '--color': `var(--theme-color-${index + 1},#000)` }"
            v-for="(item, index) in data.projectName"
            :key="index"
          >
            <div class="block-color"></div>
            <!-- <div>{{ sequence[index] }}</div> -->
            <div>{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { baseSvg } from './svg-components/index';
import { ref, onMounted, computed } from 'vue';
import {
  selfAdaption,
  pcModulePatientSex7,
  useDataAssembly
  // sequence
} from './hooks';
const props = defineProps<{
  tableHeaderList: Array<{ label: Array<string>; prop: string }>;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();
let data = useDataAssembly(props.tableHeaderList, props.tableDataList);

let dataArrCeil = computed(() => {
  return Math.floor(data.value.tipData.length / 2);
});

const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
  pcModulePatientSex7(TaskRef.value, dataArrCeil.value);
});
</script>

<style lang="scss" scoped>
@import './index.scss';
.patient-sex {
  @include patientSex();
  .contnet {
    @include content();
    position: relative;
    .contnet-warp {
      margin: 0 auto;
      margin-top: 28px;
      height: 523px;
      width: 679.32px;
      position: relative;
      .contnet-warp-round {
        @include alignCenter();
        border-radius: 100%;
        width: 235.61px;
        height: 235.61px;
        position: absolute;
        border: 2px solid var(--theme-color-1, #000);
        .contnet-warp-round-icon {
          z-index: 9;
          width: 177px;
          height: 177px;
          background-color: var(--theme-color-1, #000);
          border-radius: 100%;
          @include alignCenter();
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
        }
        .contnet-warp-round-item {
          z-index: 9;
          width: 20px;
          height: 20px;
          background-color: var(--color);
          border-radius: 100%;
          border: 2px solid #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          @include alignCenter();
          color: #fff;
        }
        .contnet-warp-round-arrow {
          @include alignCenter();
          width: 100%;
          height: 100%;
          border-radius: 100%;
          &::before {
            position: absolute;
            content: '';
            width: 9px;
            height: 2px;
            left: 87px;
            top: -2px;
            transform-origin: bottom;
            transform: rotate(25deg);
            background-color: var(--theme-color-1, #000);
          }
        }
        .contnet-warp-round-text {
          z-index: 9;
          @include alignCenter();
          width: 100%;
          height: 100%;
          border-radius: 100%;
          .contnet-warp-round-text-r {
            width: 100%;
            height: 100%;
            border-radius: 100%;
            position: relative;

            .inner {
              left: 20px;
              top: -201px;
              position: absolute;
              width: 190px;
              height: 117px;
              border-radius: 12px;
              .white {
                z-index: -2;
                position: absolute;
                width: 190px;
                height: 117px;
                border-radius: 12px;
                background-color: #fff;
              }
              .bg {
                opacity: $--opacityText;
                z-index: -1;
                position: absolute;
                width: 190px;
                height: 117px;
                border-radius: 12px;
                background-color: var(--color);
              }
              .tip {
                position: absolute;
                width: 190px;
                height: 117px;
                border-radius: 12px;
                border: 1px solid var(--color);
                display: flex;

                justify-content: center;
                align-items: center;
                > div {
                  @include text();
                }
              }
            }
          }
        }
        .contnet-warp-round-line {
          @include alignCenter();
          width: 100%;
          height: 100%;
          border-radius: 100%;
          &::after {
            transform: rotate(90deg);
            position: absolute;
            content: '';
            width: 120px;
            height: $--tipsLine;
            left: 56px;
            top: -70px;
            background-color: var(--color);
          }
        }
      }
    }
    .content-name {
      margin-top: 50px;
      height: 100px;
      width: 100%;
      display: flex;
      justify-content: center;
      > div {
        display: flex;
        width: 80%;
        justify-content: center;

        > div {
          margin: 0 10px;
          display: flex;
          width: 100%;
          > div:nth-child(1) {
            margin-right: 5px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 600;
            color: #0f0f0f;
          }
          > div:nth-child(2) {
            @include bottomText();
          }
        }
      }
    }
  }
}
</style>
